import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { IStaticContentfulImages } from 'src/types/contentful';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import HeadingAndSupportingTextWithActions from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import Button from 'src/app/atoms/Button/Button';

const IntegrationsImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      highlightImage: contentfulAsset(contentful_id: { eq: "5iZgYoL8ZD1XlfqSwOgjKg" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  const renderActions = () => (
    <Stack paddingTop='spacing-4xl'>
      <Button
        variant='primary'
        size='xl'
        href='/product/embeds-integrations'
      >
        Explore Embeds & Integrations
      </Button>
    </Stack>
  );

  return (
    <ImageAndContent
      image={{
        imageProps: {
          image: images.highlightImage.gatsbyImageData,
          alt: 'Integrations',
        },
        radius: 'radius-2xl',
        maxWidth: 980,
      }}
      content={
        <HeadingAndSupportingTextWithActions
          maxWidth='width-2xl'
          direction='column'
          justify='center'
          align='flex-start'
          gap='spacing-3xl'
          heading={{
            type: 'heading',
            text: 'We play nice with others',
            size: '2xl',
            fontWeight: 'font-weight-semibold',
          }}
          subHeading={{
            text: 'Embeds & Integrations',
            size: 'xl',
            type: 'paragraph',
            color: 'text-brand-secondary',
            fontWeight: 'font-weight-semibold',
          }}
          subHeadingGap='spacing-lg'
          supportingText={{
            type: 'paragraph',
            text: 'Tech stack headaches? Never heard of them. Connect what you love to Mighty and see why the sum is more than the parts. ',
            size: 'xl',
            color: 'text-tertiary',
          }}
          actions={renderActions()}
        />
      }
    />
  );
};

export default IntegrationsImageAndContent;
